import { MutationTree } from 'vuex';
import { AdminState } from './types';
import { EventRegistration, EventTicket } from '../models/EventRegistration';

export const mutations: MutationTree<AdminState> = {
    storeLoading(state, loading: boolean) {
        state.loading = loading;
    },
    storeEventRegistrations(state, eventRegistrations: EventRegistration[]) {
        state.eventRegistrations = eventRegistrations;
    },
    storeEventTickets(state, eventTickets: EventTicket[]) {
        state.eventTickets = eventTickets;
    },
};
